import BaseComponent from "@js/components/base_component.jsx";

class MuiCampaignsIndexTable extends BaseComponent {

  render() {
    return this.props.campaigns.length > 0 ? (
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="column-name" style={{width: "160px"}}>{ this._renderHeading("date") }</th>
            <th className="column-name">{ this._renderHeading("subject") }</th>
            <th className="column-name">{ this._renderHeading("from_domain") }</th>
            {
              this.props.show_customer_identifiers &&
                <th className="column-name">{ this._renderHeading("ccustid") }</th>
            }
            <th className="column-name text-right" style={{width: "90px"}}>{ this._renderHeading("pct_inbox") }</th>
            <th className="column-name text-right" style={{width: "90px"}}>{ this._renderHeading("pct_bulk") }</th>
            <th className="column-name text-right" style={{width: "90px"}}>{ this._renderHeading("pct_missing") }</th>
            <th className="column-actions" style={{width: "100px"}}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{this._renderRows()}</tbody>
      </table>
    ) : (
      <EmptyTableNotification type={I18n.t("sections.campaigns")} offerNew={ false } />
    );
  }

  _renderRows() {
    return this.props.campaigns.map((campaign, i) => {
      return (
        <tr key={ i }>
          <td>{ campaign.date_short }</td>
          <td>{ campaign.subject }</td>
          <td>{ campaign.from_domain }</td>
          {
            this.props.show_customer_identifiers &&
              <td>{ campaign.ccustid }</td>
          }
          <td className="text-right">{ this._percent(campaign.pct_inbox) }</td>
          <td className="text-right">{ this._percent(campaign.pct_bulk) }</td>
          <td className="text-right">{ this._percent(campaign.pct_missing) }</td>
          <td className="text-right index-buttons">
            <ButtonView
              href={ Routes.mui_campaign_path(campaign.id) }
              size="small"
            />
          </td>
        </tr>
      );
    });
  }

  _renderHeading(col) {
    let dirDecorator = "";
    let dir = "desc";

    if ( col === this.props.sort_col ) {
      if ( this.props.sort_dir === "asc" ) {
        dirDecorator = <span>&nbsp;&uarr;</span>;
      } else {
        dirDecorator = <span>&nbsp;&darr;</span>;
        dir = "asc";
      }
    }

    return (
      <span>
        <a
          href="#"
          className="mui-sortable-header"
          onClick={ (e) => { e.preventDefault(); this.props.onChangeSort(col, dir); } }
        >
          { t(`headings.${ col }`) }
        </a>
        { dirDecorator }
      </span>
    );
  }

  _percent(value) {
    if ( value === null || value === undefined ) {
      return null;
    }

    return parseFloat(value).toFixed(1);
  }

}

export default MuiCampaignsIndexTable;
